import { Link } from "react-router-dom";
import axios from 'axios';
import config from '../../config/config';
import { CLEANUP_MESSAGE, ERROR_MESSAGE, SUCCESS_MESSAGE } from '../../common/Constant';
import { toastSuccess } from '../../common/Toast';


const DeleteConfirmation = ({ CleanupConformationApiUrl }) => {

    function handleDeletePopup() {
        const token = localStorage.getItem("Token");
        // const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
        axios.post(
            `${CleanupConformationApiUrl}`, {},
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': token
                }
            }
        ).then(() => {
            toastSuccess(CLEANUP_MESSAGE);
            window.location.reload();
        })
    };

    return (
        <>
            <div className="modal fade" id="CleanupConfirmationModal" tabIndex={-1} aria-labelledby="delete" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="card-title">Confirmation</h6>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <p className=""> Are you sure you want to clean ALL deleted Data?</p>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <Link to="#" className="btn btn-primary btn-md me-1" data-bs-dismiss="modal" onClick={() => handleDeletePopup()}>Delete </Link>
                            <Link to="#" className="btn btn-dark btn-md me-1" data-bs-dismiss="modal">Cancel </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DeleteConfirmation;